export const countries = [
  { id: 0, name: "Overall" },
  { id: 1, name: "Afghanistan", code: "AF", status: "1" },
  { id: 2, name: "Bangladesh", code: "BD", status: "1" },
  { id: 3, name: "Gambia", code: "GM", status: "1" },
  { id: 4, name: "Gaza Palestine", code: "GZ", status: "1" },
  { id: 5, name: "Indonesia", code: "ID", status: "1" },
  { id: 6, name: "Malawi", code: "MW", status: "1" },
  { id: 7, name: "Mauritania", code: "MR", status: "1" },
  { id: 8, name: "Albania", code: "AL", status: "1" },
  { id: 9, name: "Niger", code: "NE", status: "1" },
  { id: 10, name: "Pakistan", code: "PK", status: "1" },
  { id: 11, name: "Senegal", code: "SN", status: "1" },
  { id: 12, name: "Somalia", code: "SO", status: "1" },
  { id: 13, name: "Sri Lanka", code: "LK", status: "1" },
  { id: 14, name: "Sudan", code: "SD", status: "1" },
  { id: 15, name: "Turkey/Syria", code: "TR", status: "1" },
  { id: 16, name: "Yemen", code: "YE", status: "1" },
  { id: 17, name: "Mali", code: "ML", status: "1" },
  { id: 18, name: "Mexico", code: "MX", status: "1" },
  { id: 19, name: "Haiti", code: "HT", status: "1" },
  { id: 20, name: "United Kingdom", code: "GB", status: "1" },
  { id: 21, name: "South Africa", code: "ZA", status: "0" },
  { id: 22, name: "India", code: "IN", status: "1" },
  { id: 23, name: "Nigeria", code: "NG", status: "1" },
  { id: 24, name: "Tanzania", code: "TZ", status: "1" },
  { id: 25, name: "Uganda", code: "UG", status: "1" },
  { id: 26, name: "France", code: "FR", status: "0" },
  { id: 27, name: "Canada", code: "CA", status: "0" },
  { id: 28, name: "Morocco", code: "MA", status: "1" },
  { id: 29, name: "Jerusalem", code: "IL", status: "1" },
  { id: 30, name: "Lebanon", code: "LB", status: "1" },
  { id: 31, name: "Syria", code: "SY", status: "1" },
  { id: 32, name: "Rwanda", code: "RW", status: "1" },
  { id: 33, name: "Kashmir India", code: "JK", status: "1" },
  { id: 34, name: "Mirpur Pakistan", code: "AJK", status: "1" },
];

export const formattedCountries = [
  { value: 0, label: "Overall" },
  { value: 1, label: "Afghanistan", code: "AF", status: "1" },
  { value: 2, label: "Bangladesh", code: "BD", status: "1" },
  { value: 3, label: "Gambia", code: "GM", status: "1" },
  { value: 4, label: "Gaza Palestine", code: "GZ", status: "1" },
  { value: 5, label: "Indonesia", code: "ID", status: "1" },
  { value: 6, label: "Malawi", code: "MW", status: "1" },
  { value: 7, label: "Mauritania", code: "MR", status: "1" },
  { value: 8, label: "Albania", code: "AL", status: "1" },
  { value: 9, label: "Niger", code: "NE", status: "1" },
  { value: 10, label: "Pakistan", code: "PK", status: "1" },
  { value: 11, label: "Senegal", code: "SN", status: "1" },
  { value: 12, label: "Somalia", code: "SO", status: "1" },
  { value: 13, label: "Sri Lanka", code: "LK", status: "1" },
  { value: 14, label: "Sudan", code: "SD", status: "1" },
  { value: 15, label: "Turkey/Syria", code: "TR", status: "1" },
  { value: 16, label: "Yemen", code: "YE", status: "1" },
  { value: 17, label: "Mali", code: "ML", status: "1" },
  { value: 18, label: "Mexico", code: "MX", status: "1" },
  { value: 19, label: "Haiti", code: "HT", status: "1" },
  { value: 20, label: "United Kingdom", code: "GB", status: "1" },
  { value: 21, label: "South Africa", code: "ZA", status: "0" },
  { value: 22, label: "India", code: "IN", status: "1" },
  { value: 23, label: "Nigeria", code: "NG", status: "1" },
  { value: 24, label: "Tanzania", code: "TZ", status: "1" },
  { value: 25, label: "Uganda", code: "UG", status: "1" },
  { value: 26, label: "France", code: "FR", status: "0" },
  { value: 27, label: "Canada", code: "CA", status: "0" },
  { value: 28, label: "Morocco", code: "MA", status: "1" },
  { value: 29, label: "Jerusalem", code: "IL", status: "1" },
  { value: 30, label: "Lebanon", code: "LB", status: "1" },
  { value: 31, label: "Syria", code: "SY", status: "1" },
  { value: 32, label: "Rwanda", code: "RW", status: "1" },
  { value: 33, label: "Kashmir India", code: "JK", status: "1" },
  { value: 34, label: "Mirpur Pakistan", code: "AJK", status: "1" },
];

export const mealPlanningCountries = [
  { id: "1", name: "Afghanistan", code: "AF", status: "1" },
  { id: "2", name: "Bangladesh", code: "BD", status: "1" },
  { id: "3", name: "Gambia", code: "GM", status: "1" },
  { id: "6", name: "Malawi", code: "MW", status: "1" },
  { id: "7", name: "Mauritania", code: "MR", status: "1" },
  { id: "9", name: "Niger", code: "NE", status: "1" },
  { id: "11", name: "Senegal", code: "SN", status: "1" },
  { id: "12", name: "Somalia", code: "SO", status: "1" },
  { id: "13", name: "Sri Lanka", code: "LK", status: "1" },
  { id: "14", name: "Sudan", code: "SD", status: "1" },
  { id: "16", name: "Yemen", code: "YE", status: "1" },
  { id: "17", name: "Mali", code: "ML", status: "1" },
  { id: "34", name: "Mirpur Pakistan", code: "AJK", status: "1" },
];
